import React from 'react';
import HeaderComponent from 'components/header/HeaderComponent';
import FooterComponent from 'components/footer/FooterComponent';
import { Outlet } from 'react-router-dom';

const MainPageLayout: React.FunctionComponent = () => {
  return (
    <>
      <HeaderComponent />
      <div className="min-vh-100-less-footer">
        <Outlet />
      </div>
      <FooterComponent />
    </>
  );
};

export default MainPageLayout;
